import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import dynamic from 'next/dynamic'
import creatorStyles from '../styles/Creator.module.css'
import Image from "next/image"
import Badge from "react-bootstrap/Badge"
import RegisterModal from "../components/User/RegisterModal"
import { useState } from 'react'
import codePlayback from '../components/Gthr/Editor/Utils/CodePlaybackDemo'

const CodeMirror = dynamic(()=>import("../components/Gthr/Creator/CodeMirror"), {
    ssr: false
  })


export default function Home() {

    const [registerModal, setRegisterModal] = useState(false)

    return (
        <Container> 

            <RegisterModal 
                    show={registerModal} 
                    setShow={setRegisterModal}
                    next={`creator`}
                    
                />
            <div className={creatorStyles.row}>
     
                    <div className={creatorStyles.left}>
                    <br/> <br/>
                        <h1 className={creatorStyles.headline}>
                         <span className={creatorStyles.gradient_text}>1:1</span> Web Development Tutoring
                        </h1>
                        <br/>
                        <p className={creatorStyles.subtext}>
                            <em>OrdinaryCoders connects high school students to computer science majors at 
                                top univerisites for online web development lessons using a collaborative code editor
                            </em> 
                        </p>
                   
                        <p >
                            <ul>
                                <li>Intended for beginners and newcomers to gain comfort in coding</li>
                                <li>Develop skills and projects to stand-out in college applications</li>
                                <li>For parents and high school students, book a free demo of the platform </li>
                                
                            </ul>
                            
                        </p>
                        <br/>

                        <Button className={creatorStyles.btn_grad}  onClick={e => setRegisterModal(true) }>Book a 10 minute Consultation</Button>

                        <br/> <br/> <br/> <br/>

                        <p className='text-muted'>
                   
                        </p>
                    </div>
                    
                <div className={creatorStyles.right}>
                    <div style={{minHeight:'600px', position:'relative'}}>
                        <CodeMirror 
                            codeSnippet={''}
                            codePlayback={codePlayback}
                        />

                    </div>
                    <div className={creatorStyles.row}>
                        <div className={creatorStyles.guest_div} >  
                            <Image
                                    src={`https://d2gdtie5ivbdow.cloudfront.net/static/img/man1-waive.jpg`}
                                    height={150}
                                    width={150}
                                    objectFit="cover"
                                    className={creatorStyles.creator_image} 
                                />

                        </div>
                       
                        <p className={creatorStyles.caption}>live video chat + collaborative code editor</p>
                        <div className={creatorStyles.creator_div} >
                            <Image
                                    src={`https://d2gdtie5ivbdow.cloudfront.net/static/img/women1_waive.jpg`}
                                    height={150}
                                    width={150}
                                    objectFit="cover"
                                    className={creatorStyles.creator_image} 
                                    
                                    
                                />                

                        </div>
                       
                    </div>
                    <div className="text-center mt-2">
                        <p className={creatorStyles.caption_mobile}>live video chat + collaborative code editor</p>
                    </div>
                </div>

            </div>
            

            <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> 
                 <div>

                     <Row className={creatorStyles.row_bottom}>
                         <Col sm={12} md={6}>
                         <Image
                                    src={`https://d2gdtie5ivbdow.cloudfront.net/static/img/Group+4.png`}
                                    height={460}
                                    width={550}
                           
                              
                         
                                />
                      
                        
                         </Col>
                         <Col className="d-flex align-items-center">
                             <div>
                             <h3 className={creatorStyles.subheadline}>How It Works</h3>
                                <p className={creatorStyles.subtext}>
                                       After a brief consultation, your child will be matched with a college student
                                       currently majoring in STEM related field.  Twice a week your child will meet 
                                       online with their tutor to learn to code and more specifically, develop websites and web apps.
                                        Covering HTML, CSS, Javascript and front-end frameworks such as React.
                                        You&apos;re teenager will develop the actual skills used by current software engineers.
                                </p>

                             </div>
                     
                         </Col>
                     </Row>
                     <Row className={creatorStyles.row_bottom} >
                         <Col sm={12} md={6}>
                         <Image
                                src={`https://d2gdtie5ivbdow.cloudfront.net/static/img/Group+6.png`}
                                height={460}
                                width={556}
                       
                         
                                />
                         </Col>
                         <Col className="d-flex align-items-center">
                         <div>
                            <h3 className={creatorStyles.subheadline}>Our Tutors</h3> 
                                <p className={creatorStyles.subtext}>
                                    Provide personalized 1-on-1 support from your browser<br/><br/>
                                           
                                    <Badge pill bg="purple-100" style={{color:'#6301ED', padding:'6px 10px', margin:'4px 2px'}}>
                                    Coming Soon
                                    </Badge> React, Next.js, cohort groups, and live events
                                </p>
                         </div>
                
                         </Col>
                     </Row>

                     <Row className={creatorStyles.row_bottom}>
                         <Col sm={12} md={6} className="d-flex align-items-center order-2">
                             <div>
                                    <h3 className={creatorStyles.subheadline}>Collaborative Code Editor</h3>
                                    <p className={creatorStyles.subtext}>
                                        See your tutor&apos;s cursor and highlighting to ensure a seamless learning experience.

                                    </p>
                             </div>
        
                         </Col>
                         <Col className="order-1">
                         <Image
                                    src={`https://d2gdtie5ivbdow.cloudfront.net/static/img/Group+11.png`}
                                    height={400}
                                    width={664}
                    
                                 
                                />
                         </Col>
                     </Row>
                     
                     <Row className={creatorStyles.row_bottom} >
                         <Col sm={12} md={6}>
                         <Image
                                src={`https://d2gdtie5ivbdow.cloudfront.net/static/img/Group+6.png`}
                                height={460}
                                width={556}
                       
                         
                                />
                         </Col>
                         <Col className="d-flex align-items-center">
                         <div>
                            <h3 className={creatorStyles.subheadline}>Learning Path</h3> 
                                <p className={creatorStyles.subtext}>
                                   Specific learning path to tackle in-demand skills<br/><br/>.  We don&apos;t want
                                   students to just learn how to code.  We also want them to get a head-start
                                   on their resumes, personal sites, and even startup ideas. To meet these goals,
                                   many of the projects with your tutor will involve re-creating existing 
                                   startup websites and products
                                           
                                    <Badge pill bg="purple-100" style={{color:'#6301ED', padding:'6px 10px', margin:'4px 2px'}}>
                                    Coming Soon
                                    </Badge> React, Next.js, cohort groups, and live events
                                </p>
                         </div>
                
                         </Col>
                     </Row>
                <div/>
            </div>
            <br/> <br/>
            <div className="text-left d-flex justify-content-center">
                <div className={creatorStyles.card}>
                 
                    {/* <Badge pill bg="purple-100" className={creatorStyles.card_headline}>
                    !
                    </Badge>  */}
                    <div className={creatorStyles.card_headline}>Features</div>
                    {/* <hr></hr> */}
                    <div className={creatorStyles.card_body}>
                        <ul>
                            <li>1 on 1 tutoring from current students and recent graduates from  top universities</li>
                            <li>Online collaborative editor for seamless learning</li>
                            <li>Learn in-demand coding skills to prepare for job market</li>
                            <li>Build a portfolio of projects</li>
                            <li>Unlimited access to web development course to supplement live lessons</li>
                            <li>Gain valuable mentorship</li>
                        </ul>
                    </div>
     
                </div>
            </div> 
            <br/> <br/> <br/> <br/> <br/> 

            <div className="text-left d-flex justify-content-center">
                <div className={creatorStyles.card}>
                 
                    {/* <Badge pill bg="purple-100" className={creatorStyles.card_headline}>
                      $
                    </Badge>  */}
                    <div className={creatorStyles.card_headline}>Pricing</div>
                    {/* <hr></hr> */}
                    <div className={creatorStyles.card_body}>
                        <ul>
                            <li>Book consultation for pricing</li>
                        </ul>
                        <Button className={creatorStyles.btn_grad}  onClick={e => setRegisterModal(true) }>Book Consultation</Button>
                    </div>
                </div>
            </div> 

            <br/> <br/> <br/> <br/> <br/> <br/> 

        </Container>


    )
}